"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatText;

function formatText(text) {
  return text.replace(/\\/gm, "\\\\").replace(/\r?\n/gm, "\\n").replace(/;/gm, "\\;").replace(/,/gm, "\\,");
}


//////////////////
// WEBPACK FOOTER
// ./~/ics/dist/utils/format-text.js
// module id = 104
// module chunks = 14